import React, { useEffect, useState } from 'react';
import Modal from '@/ctComponents/Modal';
import { createPortal } from 'react-dom';
import { TableV2 } from '@/components/TableV2';
import { getHelpCenterVideoViewers } from '@/actions';
import LoadingV2 from '@/components/Loading';
import { Icon } from '@/components/Icon';
import { Icons } from '@/assets';

export const ViewersList = ({ show, setShow, videoId }) => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setIsLoading(true);
    getHelpCenterVideoViewers(videoId)
      .then((res) => {
        setData(res.data.viewers);
        setFilteredData(res.data.viewers);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [videoId]);

  useEffect(() => {
    if (searchTerm) {
      setFilteredData(
        data.filter((item) =>
          item.uname.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    } else {
      setFilteredData(data);
    }
  }, [searchTerm]);

  const handleClose = () => {
    setShow(false);
  };

  const TABLE_HEADERS = ['#', 'Company Name', 'Date ', 'Time'];

  const prepareTableData = () => {
    return filteredData.map((item, index) => ({
      uuid: item.uid,
      cellData: [
        index + 1,
        item.uname || '-',
        new Date(item.date).toLocaleString(undefined, {
          month: '2-digit',
          day: '2-digit',
          year: '2-digit',
        }),
        new Date(item.date).toLocaleString(undefined, {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        }),
      ],
    }));
  };

  return createPortal(
    <Modal
      show={show}
      setShow={setShow}
      icon="users"
      title="Viewers List"
      customHandleClose={handleClose}
      titleColor="#131517"
      buttonPosition="end"
      minWidth={'unset'}
      children={
        <div className="overflow-x-auto min-w-360 md:min-w-795 md:max-w-795 w-full">
          <p className="text-sm text-secondary-text my-6">
            See which users watched this video and when.
          </p>
          <div>
            <div className="flex items-center gap-2 h-10 px-3 bg-white rounded-md border border-border-tertiary border-solid">
              <Icon src={Icons.searchIcon} width={24} height={24} />
              <input
                disabled={isLoading}
                type="text"
                placeholder="Search by Name..."
                className="border-none w-full shadow-none bg-transparent text-sm placeholder-secondary-text placeholder-opacity-70 outline-none"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="w-full mt-4">
            {isLoading ? (
              <div className="flex items-center justify-center my-6">
                <LoadingV2 />
              </div>
            ) : (
              <TableV2
                minWidth={760}
                headers={TABLE_HEADERS}
                data={prepareTableData()}
                emptyMessage="No viewers yet"
                subEmptyMessage="This video hasn’t been watched by any users."
              />
            )}
          </div>
        </div>
      }
    />,
    document.body
  );
};
